<template>
    <section class="tables">
        <vue-snotify></vue-snotify>
        <div class="row mt-5">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title">About Us Content</h4>
                    </div>
                    <div class="card-body">
                        <form class="forms-sample" enctype="multipart/form-data" method="post" @submit.prevent="updateHomeContent"
                            autocomplete="off">
                            <div class="row mt-5">
                                <div class="col-md-12 d-flex align-items-stretch grid-margin">
                                    <div class="row flex-grow">
                                        <div class="col-12">
                                            <div class="">
                                                <div class="">
                                                    <div class="row">
                                                        <div class="col-md-12">
                                                            <div role="group" class="form-group">
                                                                <label for="PreLoginAboutUsText1" class="d-block">About Us Text 1</label>
                                                                <div>
                                                                    <ckeditor id="PreLoginAboutUsText1"
                                                                        v-model="webinarContentData.PreLoginAboutUsText1" :config="editorConfig">
                                                                    </ckeditor>
                                                                </div>
                                                                <div v-if="$v.webinarContentData.PreLoginAboutUsText1.$error"
                                                                    class=" text-danger error-message">
                                                                    This is a required field.
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-12">
                                                            <div role="group" class="form-group">
                                                                <label for="PreLoginAboutUsText2" class="d-block">About Us Text 2</label>
                                                                <div>
                                                                    <ckeditor id="PreLoginAboutUsText2"
                                                                        v-model="webinarContentData.PreLoginAboutUsText2" :config="editorConfig1">
                                                                    </ckeditor>
                                                                </div>
                                                                <div v-if="$v.webinarContentData.PreLoginAboutUsText2.$error"
                                                                    class=" text-danger error-message">
                                                                    This is a required field.
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-12">
                                                            <div role="group" class="form-group">
                                                                <label for="PreLoginAboutUsText3" class="d-block">About Us Text 3</label>
                                                                <div>
                                                                    <ckeditor id="PreLoginAboutUsText3"
                                                                        v-model="webinarContentData.PreLoginAboutUsText3" :config="editorConfig2">
                                                                    </ckeditor>
                                                                </div>
                                                                <div v-if="$v.webinarContentData.PreLoginAboutUsText3.$error"
                                                                    class=" text-danger error-message">
                                                                    This is a required field.
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-12">
                                                            <div role="group" class="form-group">
                                                                <label for="PreLoginAboutUsText4" class="d-block">About Us Text 4</label>
                                                                <div>
                                                                    <ckeditor id="PreLoginAboutUsText4"
                                                                        v-model="webinarContentData.PreLoginAboutUsText4" :config="editorConfig3">
                                                                    </ckeditor>
                                                                </div>
                                                                <div v-if="$v.webinarContentData.PreLoginAboutUsText4.$error"
                                                                    class=" text-danger error-message">
                                                                    This is a required field.
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-md-6"></div>
                                                        <div class="col-md-6 mt-3">
                                                            <b-button type="submit" variant="success"
                                                                class="btn float-right btn-success">
                                                                Submit
                                                            </b-button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import Vue from "vue";
import API from '@/api'
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import CKEditor from 'ckeditor4-vue';

Vue.use(CKEditor);

export default {
    name: "scott_message",
    mixins: [validationMixin],
    data() {
        return {
            webinarContentData: {
                PreLoginAboutUsText1: "",
                PreLoginAboutUsText2: "",
                PreLoginAboutUsText3: "",
                PreLoginAboutUsText4: "",
            },
            editorConfig: { 
                versionCheck: false 
            },
            editorConfig1: { 
                versionCheck: false 
            },
            editorConfig2: { 
                versionCheck: false 
            },
            editorConfig3: { 
                versionCheck: false 
            }
        }
    },
    validations: {
        webinarContentData: {
            PreLoginAboutUsText1: {
                required
            },
            PreLoginAboutUsText2: {
                required
            },
            PreLoginAboutUsText3: {
                required
            },
            PreLoginAboutUsText4: {
                required
            },
        }
    },
    methods: {
        updateHomeContent() {
            this.$v.webinarContentData.$touch();
            if (this.$v.webinarContentData.$anyError) {
                return;
            }
            API.updateHomeContent(this.webinarContentData , this.updateHomeContentCB, this.errorCB)
        },
        updateHomeContentCB(res) {
            this.webinarContentData = res.data;
            this.$showNotification({message:"Updated Successfully"}, 'success')
        },
        getWebContent() {
            API.getWebContent(this.getWebContentCB, this.errorCB)
        },
        getWebContentCB(res) {
            this.webinarContentData = res.data;
            this.$showNotification(res, 'success')
        },
        errorCB(err) {
            console.log(err);
            this.$showNotification({ message: "Failed system error" }, 'error')
        },
    },
    mounted() {
        this.getWebContent();
    },
    components: {}
}
</script>
